import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./login/Login";
import UserList from "./admin/user/UserList";
import UserInvitationList from "./admin/user/UserInvitationList";
import UserSendInvitation from "./admin/user/UserSendInvitation";
import { Layout } from "antd";
import { ROUTES } from "../constant/routeConstant";
import SystemParameterList from "./setup/SystemParameter/SystemParameterList";
import SystemParameterAdd from "./setup/SystemParameter/SystemParameterAdd";
import SystemParameterDetail from "./setup/SystemParameter/SystemParameterDetail";
import SystemParameterEdit from "./setup/SystemParameter/SystemParameterEdit";
import DepotConfig from "./setup/DepotConfig/DepotConfigList";
import DepotConfigAdd from "./setup/DepotConfig/DepotConfigAdd";
import DepotConfigDetail from "./setup/DepotConfig/DepotConfigDetail";
import DepotConfigEdit from "./setup/DepotConfig/DepotConfigEdit";
import AdditionalProofsList from "./setup/AdditionalProofs/AdditionalProofsList";
import AdditionalProofsAdd from "./setup/AdditionalProofs/AdditionalProofsAdd";
import AdditionalProofsDetail from "./setup/AdditionalProofs/AdditionalProofsDetail";
import AdditionalProofsEdit from "./setup/AdditionalProofs/AdditionalProofsEdit";
import UserDetail from "./admin/user/UserDetail";
import SelectPortal from "./login/SelectPortal";
import UserEdit from "./admin/user/UserEdit";
import AddressFormatConfigList from "./setup/addressFormatConfig/AddressFormatConfigList";
import AddressFormatConfigEdit from "./setup/addressFormatConfig/AddressFormatConfigEdit";
import SkillSetList from "./master/fleet/skillset/SkillSetList";
import SkillSetAdd from "./master/fleet/skillset/SkillSetAdd";
import SkillSetEdit from "./master/fleet/skillset/SkillSetEdit";
import SkillSetDetail from "./master/fleet/skillset/SkillSetDetail";
import VehicleList from "./master/fleet/vehicle/VehicleList";
import DetailCompanyProfile from "./setup/company-profile/detail-company-profile";
import CustomerList from "./master/customer/CustomerList";
import DriverList from "./master/fleet/driver/DriverList";
import DriverAdd from "./master/fleet/driver/DriverAdd";
import DriverDetail from "./master/fleet/driver/DriverDetail";
import MapsCustomer from "./master/customer/MapsCustomer";
import CustomerAdd from "./master/customer/CustomerAdd";
import CustomerEdit from "./master/customer/CustomerEdit";
import DriverEdit from "./master/fleet/driver/DriverEdit";
import VehicleAdd from "./master/fleet/vehicle/VehicleAdd";
import VehicleDetail from "./master/fleet/vehicle/VehicleDetail";
import VehicleEdit from "./master/fleet/vehicle/VehicleEdit";
import DeliveryTypeList from "./master/fleet/DeliveryType/DeliveryTypeList";
import DeliveryTypeAdd from "./master/fleet/DeliveryType/DeliveryTypeAdd";
import DetailDeliveryAssociate from "./master/fleet/DeliveryAssociate/detail-delivery-associate";
import MapsDepot from "./setup/DepotConfig/MapsDepot";
import CustomerDetail from "./master/customer/CustomerDetail";
import RoleList from "./admin/role/RoleList";
import RoleAdd from "./admin/role/RoleAdd";
import RoleEdit from "./admin/role/RoleEdit";
import RoleDetail from "./admin/role/RoleDetail";
import DataGroupList from "./admin/data-group/list/list-data-group";
import DataGroupAdd from "./admin/data-group/add/add-data-group";
import EditDataGroup from "./admin/data-group/edit/edit-data-group";
import DeliveryTypeEdit from "./master/fleet/DeliveryType/DeliveryTypeEdit";
import DeliveryTypeDetail from "./master/fleet/DeliveryType/DeliveryTypeDetail";
import PalletList from "./master/fleet/Pallet/PalletList";
import PalletAdd from "./master/fleet/Pallet/PalletAdd";
import PalletDetail from "./master/fleet/Pallet/PalletDetail";
import PalletEdit from "./master/fleet/Pallet/PalletEdit";
import ListTripPlanning from "./order/routes/trip-planning/list/list-trip-planning";
import LoginCompletion from "./login/login-completion/LoginCompletion";
import CompletionWithCompanyProfile from "./login/login-completion/CompletionWithCompanyProfile";
import CompletionData from "./login/login-completion/completion-data/CompletionData";
import PrivateComponent from "../component/custom-component/privateComponent";
import AllTripList from "./order/routes/AllTrip/AllTripList";
import AllTripDetail from "./order/routes/AllTrip/DetailAllTrip";
import DetailDataGroup from "./admin/data-group/detail/detail-data-group";
import AddAllTrip from "./order/routes/AllTrip/AddAllTrip";
import OrderRequestList from "./order/orderRequest/OrderRequestList";
import ListTemperatureCategory from "./setup/temperature-category/list/list-temperature";
import DetailTemperature from "./setup/temperature-category/detail/detail-temperature";
import AddTemperature from "./setup/temperature-category/add/add-temperature";
import EditTemperature from "./setup/temperature-category/edit/edit-temperature";
import ListUOM from "./setup/uom/list/list-uom";
import DetailUOM from "./setup/uom/detail/detail-uom";
import AddUOM from "./setup/uom/add/add-uom";
import EditUOM from "./setup/uom/edit/edit-uom";
import OrderRequestDetail from "./order/orderRequest/OrderRequestDetail";
import LoginSuccess from "./login/LoginSuccess";
import MainEditCompanyProfile from "./setup/company-profile/edit/main-edit";
import OrderRequestAdd from "./order/orderRequest/OrderRequestAdd";
import EditAllTrip from "./order/routes/AllTrip/EditAllTrip";
import LoginInvitation from "./login/LoginInvitation";
import LoginCompletionFailed from "./login/LoginCompletionFailed";
import LoginCompletionSuccess from "./login/LoginCompletionSuccess";
import WelcomePage from "./welcome-page/welcome";
import DetailTripPlanning from "./order/routes/trip-planning/detail/DetailTripPlanning";
import DetailInTripPlanning from "./order/routes/trip-planning/detail/DetailInTripPlanning";
import ErrorPage400 from "./error/ErrorPage400";
import ErrorPage401 from "./error/ErrorPage401";
import ErrorPage403 from "./error/ErrorPage403";
import ErrorPage404 from "./error/ErrorPage404";
import ErrorPage500 from "./error/ErrorPage500";
import MainAddTripPlanning from "./order/routes/trip-planning/add/add-trip-planning";
import SellerList from "./master/seller/SellerList";
import SellerDetail from "./master/seller/SellerDetail";
import GromartOrderRequestList from "./order/gromartOrderRequest/GromartOrderRequestList";
import GromartOrderRequestDetail from "./order/gromartOrderRequest/GromartOrderRequestDetail";
import DeliveryPaymentList from "./report/deliveryPayment/DeliveryPaymentList";
import OrderGroupPaymentList from "./order/orderGroupPayment/OrderGroupPaymentList";
// import OrderGroupPaymentDetail from "./order/orderGroupPayment/OrderGroupPaymentDetail";
import ShippingCostList from "./order/shippingCostPayment/ShippingCostList";
import DetailShippingCost from "./order/shippingCostPayment/DetailShippingCost";
import Dashboard from "./dashboard/Dashboard";
import DeliveryAssociateList from "./master/fleet/DeliveryAssociate/list/DeliveryAssociateList";
import MainAddDeliveryAssociate from "./master/fleet/DeliveryAssociate/MainAddDeliveryAssociate";
import MainEditDeliveryAssociate from "./master/fleet/DeliveryAssociate/edit/MainEditDeliveryAssociate";
import ReportLog from "./report/reportLog/ReportLog";
import MainReportOrder from "./report/reports/report-order/MainReportOrder";
import MainReportDeliveryAssociate from "./report/reports/report-delivery-associate/MainReportDeliveryAssociate";
import MainReportTrip from "./report/reports/report-trip/MainReportTrip";
import MainReportDepot from "./report/reports/report-depot/MainReportDepot";
import MainInvoice from "./order/invoice/MainInvoice";

const Main = () => {
  return (
    // isLogin ? (
    <>
      <Layout style={{ height: "auto", minHeight: "100vh" }}>
        {/* <Headbar /> */}
        <Layout>
          {/* <Sidebar /> */}
          <Layout.Content>
            <Routes>
              <Route path={ROUTES.INDEX} element={<Login />} exact />
              <Route
                path={ROUTES.LOGIN_INVITATION}
                element={<LoginInvitation />}
                exact
              />
              <Route
                path={ROUTES.LOGIN_SUCCESS}
                element={<LoginSuccess />}
                exact
              />
              <Route
                path={ROUTES.LOGIN_INVITATION_FAILED}
                element={<LoginCompletionFailed />}
                exact
              />
              <Route
                path={ROUTES.LOGIN_INVITATION_SUCCESS}
                element={<LoginCompletionSuccess />}
                exact
              />
              <Route
                path={ROUTES.SELECT_PORTAL}
                element={
                  <PrivateComponent component={<SelectPortal />} portal />
                }
                exact
              />
              <Route
                path={ROUTES.COMPLETION}
                element={
                  <PrivateComponent component={<LoginCompletion />} portal />
                }
              />
              <Route
                path={ROUTES.REGISTER_COMPLETION}
                element={
                  <PrivateComponent
                    component={<CompletionWithCompanyProfile />}
                    portal
                  />
                }
              />
              <Route
                path={ROUTES.COMPLETION_DATA}
                element={
                  <PrivateComponent component={<CompletionData />} portal />
                }
              />
              {/* <Route path={ROUTES.SELECT_PORTAL} element={<SelectPortal />} exact /> */}
              <Route
                path={ROUTES.USER.LIST}
                element={<PrivateComponent component={<UserList />} />}
                exact
              />
              <Route
                path={ROUTES.USER.DETAIL}
                element={<PrivateComponent component={<UserDetail />} />}
                exact
              />
              <Route
                path={ROUTES.USER.UPDATE}
                element={<PrivateComponent component={<UserEdit />} />}
                exact
              />
              <Route
                path={ROUTES.INVITATION.LIST}
                element={
                  <PrivateComponent component={<UserInvitationList />} />
                }
                exact
              />
              <Route
                path={ROUTES.INVITATION.ADD}
                element={
                  <PrivateComponent component={<UserSendInvitation />} />
                }
                exact
              />
              <Route
                path={ROUTES.PARAMETER.LIST}
                element={
                  <PrivateComponent component={<SystemParameterList />} />
                }
                exact
              />
              <Route
                path={ROUTES.PARAMETER.ADD}
                element={
                  <PrivateComponent component={<SystemParameterAdd />} />
                }
                exact
              />
              <Route
                path={ROUTES.PARAMETER.DETAIL}
                element={
                  <PrivateComponent component={<SystemParameterDetail />} />
                }
                exact
              />
              <Route
                path={ROUTES.PARAMETER.EDIT}
                element={
                  <PrivateComponent component={<SystemParameterEdit />} />
                }
                exact
              />
              <Route
                path={ROUTES.DEPOT_CONFIG.LIST}
                element={<PrivateComponent component={<DepotConfig />} />}
                exact
              />
              <Route
                path={ROUTES.DEPOT_CONFIG.ADD}
                element={<PrivateComponent component={<DepotConfigAdd />} />}
                exact
              />
              <Route
                path={ROUTES.DEPOT_CONFIG.DETAIL}
                element={<PrivateComponent component={<DepotConfigDetail />} />}
                exact
              />
              <Route
                path={ROUTES.DEPOT_CONFIG.EDIT}
                element={<PrivateComponent component={<DepotConfigEdit />} />}
                exact
              />
              <Route
                path={ROUTES.DEPOT_CONFIG.MAPS}
                element={<PrivateComponent component={<MapsDepot />} />}
                exact
              />
              <Route
                path={ROUTES.ADDITIONAL_PROOFS.LIST}
                element={
                  <PrivateComponent component={<AdditionalProofsList />} />
                }
                exact
              />
              <Route
                path={ROUTES.ADDITIONAL_PROOFS.ADD}
                element={
                  <PrivateComponent component={<AdditionalProofsAdd />} />
                }
                exact
              />
              <Route
                path={ROUTES.ADDITIONAL_PROOFS.DETAIL}
                element={
                  <PrivateComponent component={<AdditionalProofsDetail />} />
                }
                exact
              />
              <Route
                path={ROUTES.ADDRESS_FORMAT_CONFIG.LIST}
                element={
                  <PrivateComponent component={<AddressFormatConfigList />} />
                }
                exact
              />
              <Route
                path={ROUTES.ADDRESS_FORMAT_CONFIG.EDIT}
                element={
                  <PrivateComponent component={<AddressFormatConfigEdit />} />
                }
                exact
              />
              <Route
                path={ROUTES.SKILLSET.LIST}
                element={<PrivateComponent component={<SkillSetList />} />}
                exact
              />
              <Route
                path={ROUTES.SKILLSET.ADD}
                element={<PrivateComponent component={<SkillSetAdd />} />}
                exact
              />
              <Route
                path={ROUTES.SKILLSET.EDIT}
                element={<PrivateComponent component={<SkillSetEdit />} />}
                exact
              />
              <Route
                path={ROUTES.SKILLSET.DETAIL}
                element={<PrivateComponent component={<SkillSetDetail />} />}
                exact
              />
              <Route
                path={ROUTES.VEHICLE.LIST}
                element={<PrivateComponent component={<VehicleList />} />}
                exact
              />
              <Route
                path={ROUTES.VEHICLE.ADD}
                element={<PrivateComponent component={<VehicleAdd />} />}
                exact
              />
              <Route
                path={ROUTES.VEHICLE.DETAIL}
                element={<PrivateComponent component={<VehicleDetail />} />}
                exact
              />
              <Route
                path={ROUTES.COMPANY_PROFILE.DETAIL}
                element={
                  <PrivateComponent component={<DetailCompanyProfile />} />
                }
                exact
              />
              <Route
                path={ROUTES.VEHICLE.EDIT}
                element={<PrivateComponent component={<VehicleEdit />} />}
                exact
              />
              {/* <Route path={ROUTES.COMPANY_PROFILE.DETAIL} element={<DetailCompanyProfile />} exact /> */}
              <Route
                path={ROUTES.DELIVERY_TYPE.LIST}
                element={<PrivateComponent component={<DeliveryTypeList />} />}
                exact
              />
              <Route
                path={ROUTES.DELIVERY_TYPE.ADD}
                element={<PrivateComponent component={<DeliveryTypeAdd />} />}
                exact
              />
              <Route
                path={ROUTES.DELIVERY_TYPE.EDIT}
                element={<PrivateComponent component={<DeliveryTypeEdit />} />}
                exact
              />
              <Route
                path={ROUTES.DELIVERY_TYPE.DETAIL}
                element={
                  <PrivateComponent component={<DeliveryTypeDetail />} />
                }
                exact
              />
              <Route
                path={ROUTES.CUSTOMER.LIST}
                element={<PrivateComponent component={<CustomerList />} />}
                exact
              />
              <Route
                path={ROUTES.CUSTOMER.MAPS}
                element={<PrivateComponent component={<MapsCustomer />} />}
                exact
              />
              <Route
                path={ROUTES.CUSTOMER.ADD}
                element={<PrivateComponent component={<CustomerAdd />} />}
                exact
              />
              <Route
                path={ROUTES.CUSTOMER.EDIT}
                element={<PrivateComponent component={<CustomerEdit />} />}
                exact
              />
              <Route
                path={ROUTES.CUSTOMER.DETAIL}
                element={<PrivateComponent component={<CustomerDetail />} />}
                exact
              />
              <Route
                path={ROUTES.SELLER.LIST}
                element={<PrivateComponent component={<SellerList />} />}
                exact
              />
              <Route
                path={ROUTES.SELLER.DETAIL}
                element={<PrivateComponent component={<SellerDetail />} />}
                exact
              />
              <Route
                path={ROUTES.DRIVER.LIST}
                element={<PrivateComponent component={<DriverList />} />}
                exact
              />
              <Route
                path={ROUTES.DRIVER.ADD}
                element={<PrivateComponent component={<DriverAdd />} />}
                exact
              />
              <Route
                path={ROUTES.DRIVER.EDIT}
                element={<PrivateComponent component={<DriverEdit />} />}
                exact
              />
              <Route
                path={ROUTES.DRIVER.DETAIL}
                element={<PrivateComponent component={<DriverDetail />} />}
                exact
              />
              <Route
                path={ROUTES.ADDITIONAL_PROOFS.EDIT}
                element={
                  <PrivateComponent component={<AdditionalProofsEdit />} />
                }
                exact
              />
              <Route
                path={ROUTES.ROLE.LIST}
                element={<PrivateComponent component={<RoleList />} />}
                exact
              />
              <Route
                path={ROUTES.ROLE.ADD}
                element={<PrivateComponent component={<RoleAdd />} />}
                exact
              />
              <Route
                path={ROUTES.ROLE.EDIT}
                element={<PrivateComponent component={<RoleEdit />} />}
                exact
              />
              <Route
                path={ROUTES.ROLE.DETAIL}
                element={<PrivateComponent component={<RoleDetail />} />}
                exact
              />
              <Route
                path={ROUTES.DATA_GROUP.LIST}
                element={<PrivateComponent component={<DataGroupList />} />}
                exact
              />
              <Route
                path={ROUTES.DATA_GROUP.ADD}
                element={<PrivateComponent component={<DataGroupAdd />} />}
                exact
              />
              <Route
                path={ROUTES.DATA_GROUP.EDIT}
                element={<PrivateComponent component={<EditDataGroup />} />}
                exact
              />
              <Route
                path={ROUTES.DATA_GROUP.DETAIL}
                element={<PrivateComponent component={<DetailDataGroup />} />}
                exact
              />
              {/* <Route path={ROUTES.ADDRESS_FORMAT_CONFIG.LIST} element={<AddressFormatConfigList />} exact /> */}
              <Route
                path={ROUTES.DELIVERY_ASSOCIATE.LIST}
                element={
                  <PrivateComponent component={<DeliveryAssociateList />} />
                }
                exact
              />
              <Route
                path={ROUTES.DELIVERY_ASSOCIATE.ADD}
                element={
                  <PrivateComponent component={<MainAddDeliveryAssociate />} />
                }
                exact
              />
              <Route
                path={ROUTES.DELIVERY_ASSOCIATE.DETAIL}
                element={
                  <PrivateComponent component={<DetailDeliveryAssociate />} />
                }
                exact
              />
              <Route
                path={ROUTES.DELIVERY_ASSOCIATE.EDIT}
                element={
                  <PrivateComponent component={<MainEditDeliveryAssociate />} />
                }
                exact
              />
              <Route
                path={ROUTES.PALLET.LIST}
                element={<PrivateComponent component={<PalletList />} />}
                exact
              />
              <Route
                path={ROUTES.PALLET.ADD}
                element={<PrivateComponent component={<PalletAdd />} />}
                exact
              />
              <Route
                path={ROUTES.PALLET.DETAIL}
                element={<PrivateComponent component={<PalletDetail />} />}
                exact
              />
              <Route
                path={ROUTES.PALLET.EDIT}
                element={<PrivateComponent component={<PalletEdit />} />}
                exact
              />
              <Route
                path={ROUTES.TRIP_PLANNING.LIST}
                element={<PrivateComponent component={<ListTripPlanning />} />}
                exact
              />
              <Route
                path={ROUTES.TRIP_PLANNING.ADD}
                element={
                  <PrivateComponent component={<MainAddTripPlanning />} />
                }
                exact
              />
              <Route
                path={ROUTES.TRIP_PLANNING.DETAIL}
                element={
                  <PrivateComponent component={<DetailTripPlanning />} />
                }
                exact
              />
              <Route
                path={ROUTES.TRIP_PLANNING.DETAIL2}
                element={
                  <PrivateComponent component={<DetailInTripPlanning />} />
                }
                exact
              />
              <Route
                path={ROUTES.ALL_TRIP.LIST}
                element={<PrivateComponent component={<AllTripList />} />}
                exact
              />
              <Route
                path={ROUTES.ALL_TRIP.DETAIL}
                element={<PrivateComponent component={<AllTripDetail />} />}
                exact
              />
              <Route
                path={ROUTES.ALL_TRIP.ADD}
                element={<PrivateComponent component={<AddAllTrip />} />}
                exact
              />
              <Route
                path={ROUTES.ALL_TRIP.EDIT}
                element={<PrivateComponent component={<EditAllTrip />} />}
                exact
              />
              <Route
                path={ROUTES.UOM.LIST}
                element={<PrivateComponent component={<ListUOM />} />}
                exact
              />
              <Route
                path={ROUTES.UOM.ADD}
                element={<PrivateComponent component={<AddUOM />} />}
                exact
              />
              <Route
                path={ROUTES.UOM.DETAIL}
                element={<PrivateComponent component={<DetailUOM />} />}
                exact
              />
              <Route
                path={ROUTES.UOM.EDIT}
                element={<PrivateComponent component={<EditUOM />} />}
                exact
              />
              <Route
                path={ROUTES.TEMPERATURE_CATEGORY.LIST}
                element={
                  <PrivateComponent component={<ListTemperatureCategory />} />
                }
                exact
              />
              <Route
                path={ROUTES.TEMPERATURE_CATEGORY.DETAIL}
                element={<PrivateComponent component={<DetailTemperature />} />}
                exact
              />
              <Route
                path={ROUTES.TEMPERATURE_CATEGORY.ADD}
                element={<PrivateComponent component={<AddTemperature />} />}
                exact
              />
              <Route
                path={ROUTES.TEMPERATURE_CATEGORY.EDIT}
                element={<PrivateComponent component={<EditTemperature />} />}
                exact
              />
              <Route
                path={ROUTES.GROMART_ORDER.LIST}
                element={
                  <PrivateComponent component={<GromartOrderRequestList />} />
                }
                exact
              />
              <Route
                path={ROUTES.GROMART_ORDER.DETAIL}
                element={
                  <PrivateComponent component={<GromartOrderRequestDetail />} />
                }
                exact
              />
              <Route
                path={ROUTES.ORDER_REQUEST.LIST}
                element={<PrivateComponent component={<OrderRequestList />} />}
                exact
              />
              <Route
                path={ROUTES.ORDER_REQUEST.DETAIL}
                element={
                  <PrivateComponent component={<OrderRequestDetail />} />
                }
                exact
              />
              <Route
                path={ROUTES.ORDER_REQUEST.ADD}
                element={<PrivateComponent component={<OrderRequestAdd />} />}
                exact
              />
              <Route
                path={ROUTES.COMPANY_PROFILE.EDIT}
                element={
                  <PrivateComponent component={<MainEditCompanyProfile />} />
                }
                exact
              />
              <Route
                path={ROUTES.ERROR.BAD_REQUEST}
                element={<PrivateComponent component={<ErrorPage400 />} />}
                exact
              />
              <Route
                path={ROUTES.ERROR.UNAUTHORIZE}
                element={<PrivateComponent component={<ErrorPage401 />} />}
                exact
              />
              <Route
                path={ROUTES.ERROR.FORBIDDEN}
                element={<PrivateComponent component={<ErrorPage403 />} />}
                exact
              />
              <Route
                path={ROUTES.ERROR.NOT_FOUND}
                element={<PrivateComponent component={<ErrorPage404 />} />}
                exact
              />
              <Route
                path={ROUTES.ERROR.INTERNAL_SERVER_ERROR}
                element={<PrivateComponent component={<ErrorPage500 />} />}
                exact
              />
              <Route
                path={ROUTES.WELCOME}
                element={<PrivateComponent component={<WelcomePage />} />}
                exact
              />
              <Route
                path={ROUTES.BILLING_INVOICE.REPORT}
                element={<PrivateComponent component={<MainInvoice />} />}
                exact
              />
              <Route
                path={ROUTES.DELIVERY_PAYMENT.LIST}
                element={
                  <PrivateComponent component={<DeliveryPaymentList />} />
                }
                exact
              />
              <Route
                path={ROUTES.ORDER_GROUP_PAYMENT.LIST}
                element={
                  <PrivateComponent component={<OrderGroupPaymentList />} />
                }
                exact
              />
              {/* <Route
                path={ROUTES.ORDER_GROUP_PAYMENT.DETAIL}
                element={
                  <PrivateComponent component={<OrderGroupPaymentDetail/>} />
                }
                exact
              /> */}
              <Route
                path={ROUTES.SHIPPING_COST_PAYMENT.LIST}
                element={<PrivateComponent component={<ShippingCostList />} />}
                exact
              />
              <Route
                path={ROUTES.SHIPPING_COST_PAYMENT.DETAIL}
                element={
                  <PrivateComponent component={<DetailShippingCost />} />
                }
                exact
              />
              <Route
                path={ROUTES.DASHBOARD}
                element={<PrivateComponent component={<Dashboard />} />}
                exact
              />
              <Route
                path={ROUTES.LOG_REPORT.LIST}
                element={<PrivateComponent component={<ReportLog />} />}
                exact
              />
              {/* <Route
                path={ROUTES.LOG_REPORT.LIST}
                element={<PrivateComponent component={<MainLogReport />} />}
                exact
              /> */}
              <Route
                path={ROUTES.REPORT_ORDER.LIST}
                element={<PrivateComponent component={<MainReportOrder />} />}
                exact
              />
              <Route
                path={ROUTES.REPORT_DELIVERY_ASSOCIATE.LIST}
                element={
                  <PrivateComponent
                    component={<MainReportDeliveryAssociate />}
                  />
                }
                exact
              />
              <Route
                path={ROUTES.REPORT_TRIP.LIST}
                element={<PrivateComponent component={<MainReportTrip />} />}
                exact
              />
              <Route
                path={ROUTES.REPORT_DEPOT.LIST}
                element={<PrivateComponent component={<MainReportDepot />} />}
                exact
              />
            </Routes>
          </Layout.Content>
        </Layout>
      </Layout>
    </>
    // ) : (
    //   <>
    //     <Routes>
    //       <Route path={ROUTES.INDEX} element={<Login />} exact />
    //       {/* <Route path={ROUTES.DATA_GROUP.LIST} element={<PrivateComponent component={<PrivateComponent component={<CompletionWithCompanyProfile />}  portal />} />} /> */}
    //       {/* <Route path={ROUTES.SELECT_PORTAL} element={<PrivateComponent component={<SelectPortal />} portal />} /> */}
    //     </Routes>
    //   </>
    // )
  );
};

export default Main;
